export default function ErroCarregamento({ mensagem, onRetry }) {
  return (
    <div className="empty-state">
      <span className="ms">error</span>
      <div style={{ color: 'var(--am-tinta)', fontWeight: 600, marginBottom: 4 }}>
        {mensagem || 'Não foi possível carregar os dados.'}
      </div>
      <div style={{ fontSize: 13, marginBottom: 16 }}>Verifique sua conexão e tente novamente.</div>
      {onRetry && (
        <button type="button" className="am-btn am-btn-outline" onClick={onRetry}>
          <span className="ms">refresh</span>
          Tentar novamente
        </button>
      )}
    </div>
  );
}

export function extrairMensagemErro(err, fallback = 'Não foi possível carregar os dados.') {
  return err?.response?.data?.detail || fallback;
}
